import { Tabs, TabsProps } from 'antd';
import PayrollReceipt from './PayrollReceipt';
import Receipt from './Receipt';
import styled from 'styled-components';

const RECEIPT_CONFIG_KEYS = {
  PAYROLL_RECEIPT: 'payroll-receipt',
  RECEIPT: 'receipt',
};

const items: TabsProps['items'] = [
  {
    key: RECEIPT_CONFIG_KEYS.PAYROLL_RECEIPT,
    label: 'Payroll Report',
    children: <PayrollReceipt />,
  },
  {
    key: RECEIPT_CONFIG_KEYS.RECEIPT,
    label: 'Receipt',
    children: <Receipt />,
  },
];

const ReceiptConfig = () => {
  return (
    <TabContainer>
      <StyledTabs items={items} />
    </TabContainer>
  );
};

export default ReceiptConfig;

const TabContainer = styled.div`
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
`;

const StyledTabs = styled(Tabs)`
  flex: 1;

  .ant-tabs-tab {
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ant-tabs-tab-btn {
    font-weight: 600;
    font-size: 24px;
    font-family: Poppins;
    color: #505050;
  }

  .ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #2d6772 !important;
  }

  .ant-tabs-ink-bar {
    background: #2d6772;
    height: 2px;
  }
`;
